module.exports = __webpack_public_path__ + "img/iconSystemStaff.428a0788.svg";